<div class="pill-choice-field">
  <label class="pill-choice-label" [id]="id + '-label'">
    {{ label }}
    <span *ngIf="required"> *</span>
  </label>
  <div
    class="pill-choice-group"
    [class.pill-choice-invalid]="isInvalid"
    role="radiogroup"
    [id]="id"
    tabindex="-1"
    [attr.aria-labelledby]="id + '-label'"
    [attr.aria-required]="required ? 'true' : null"
    [attr.aria-invalid]="isInvalid"
    [attr.aria-describedby]="isInvalid ? errorId : null"
  >
    <button
      #pillButton
      type="button"
      class="pill"
      role="radio"
      [attr.aria-checked]="isSelected(true)"
      [attr.tabindex]="tabIndexFor(true, 0)"
      [class.pill-selected]="isSelected(true)"
      (click)="select(true)"
      (keydown)="onKeydown($event, 0)"
    >
      {{ 'Yes' | translate }}
    </button>
    <button
      #pillButton
      type="button"
      class="pill"
      role="radio"
      [attr.aria-checked]="isSelected(false)"
      [attr.tabindex]="tabIndexFor(false, 1)"
      [class.pill-selected]="isSelected(false)"
      (click)="select(false)"
      (keydown)="onKeydown($event, 1)"
    >
      {{ 'No' | translate }}
    </button>
  </div>
  <p [id]="errorId" class="pill-choice-error" *ngIf="isInvalid">
    {{ errorText }}
  </p>
</div>
